export const feedbackMessageId = (item) => {
  const candidate = typeof item?.server_id === "number" ? item.server_id : item?.id;
  return Number.isInteger(candidate) ? candidate : null;
};

export const canApproveForFineTuning = ({
  trainingConsent,
  rootCause,
  correctedAnswer,
}) =>
  Boolean(trainingConsent) &&
  rootCause === "model" &&
  Boolean(String(correctedAnswer || "").trim());
